<template>
  <div>
    <div
      v-if="!promoCode && !membership && !subscription && !orderItemAccessCode"
      class="promo-code-contanier"
    >
      <v-text-field
        id="promoCodeInput"
        v-model="promoCodeInput"
        :label="isZkm ? adminText('workflowsAll.upisite_promo_kod_a8f66cc', 'Upišite promo kod') : workflowCustomerLabel('insertPromoCode', {}, $t('insertPromoCode'))"
        class="input-code"
        box
        :color="color"
        :error="invalid"
        :error-messages="errorMessage"
        :append-icon="
          !focused && !promoCodeInput.length ? 'info' : errorMessage !== '' ? 'error' : undefined
        "
        @input="handleChangeInput"
        @focus="focused = true"
        @blur="focused = false"
        @click:append="openPromoCodeDescriptionModal = true"
      />
      <v-btn
        v-show="(focused || !!promoCodeInput.length) && errorMessage === ''"
        color="white"
        class="activate-button"
        depressed
        :disabled="!promoCodeInput.length"
        style="background-color: white !important"
        @click="applyPromoCode"
      >
        {{ workflowCustomerLabel('activate', {}, $t('activate')) }}
      </v-btn>
    </div>
    <div
      v-else
      :class="['promo-code-applied-container', !isZkm && 'promo-code-applied-container-regular']"
    >
      <div v-if="membership">{{ adminText('workflowsAll.membership_is_applied_ce9cff3', 'Membership is applied.') }}</div>
      <div v-if="promoCode">{{ adminText('workflowsAll.promo_code_is_applied_134ad40', 'Promo code is applied.') }}</div>
      <div v-if="orderItemAccessCode">{{ adminText('workflowsAll.access_code_is_applied_11d60f0', 'Access code is applied.') }}</div>
      <div v-if="subscription">
        {{ adminText('workflowsAll.subscription_f2250c2', 'Subscription') }}
        {{ prepaidCouponUser.prepaidCoupon.name }}
        {{ adminText('workflowsAll.is_applied_7a32b6b', 'is applied.') }}
      </div>
      <div id="promoCodeRemove" class="promo-code-remove-button" @click="removePromoCode">
        {{ adminText('workflowsAll.remove_bd5d9aa', 'REMOVE') }}
      </div>
    </div>
    <div v-if="subscription">
      <v-radio-group v-model="couponItemId" style="padding: 0 1rem">
        <v-radio
          v-for="item of prepaidCouponUser.prepaidCoupon.couponItems"
          :key="item.id"
          color="primary"
          :label="getCouponItemLabel(item)"
          :value="item.id"
          @change="applySubscription(item.id)"
        />
      </v-radio-group>
      <p v-if="unavailablePrepaidCoupons.length" style="text-indent: 20px">
        {{ adminText('workflowsAll.nedostupno_vec_iskoristeno_b15979c', 'Nedostupno, već iskorišteno:') }}
      </p>
      <v-radio-group :disabled="true" style="margin-left: 0.125rem">
        <v-radio
          v-for="item of unavailablePrepaidCoupons"
          :key="item.id"
          color="primary"
          :label="getCouponItemLabel(item)"
          :value="item.id"
        />
      </v-radio-group>
    </div>
    <promo-code-description-modal
      v-if="openPromoCodeDescriptionModal"
      @closeModal="openPromoCodeDescriptionModal = false"
    />
  </div>
</template>
<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import { getPromoCodeByName } from '../../http'
import { isDateBetween } from '../../utils'
import PromoCodeDescriptionModal from '@/components/tickets/promo-code-description-modal.vue'

export default {
  mixins: [WorkflowDisplay],
  components: { PromoCodeDescriptionModal },
  props: {
    initialPromoCode: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: 'primary',
    },
    event: {
      type: Object,
      default: null,
    },
    vs: {
      type: Object,
      default: () => {},
    },
    promoCode: {
      type: Object,
      default: null,
    },
    membership: {
      type: Object,
      default: null,
    },
    isZkm: {
      default: false,
      type: Boolean,
    },
    orderItemAccessCode: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      promoCodeInput: '',
      invalid: false,
      errorMessage: '',
      unavailablePrepaidCoupons: [],
      prepaidCouponUser: null,
      couponItemId: null,
      subscription: null,
      focused: false,
      openPromoCodeDescriptionModal: false,
    }
  },
  mounted() {
    if (this.initialPromoCode) {
      this.promoCodeInput = this.initialPromoCode
      this.applyPromoCode()
    }
  },
  methods: {
    getCouponItemLabel(item) {
      let interests = []
      if (item.couponItemInterest.length) {
        interests = item.couponItemInterest.map(i => i.interest.name)
      }

      return item.type === 'PREFERENCES'
        ? interests.length
          ? item.performanceTypes.join(', ') + ', ' + interests.join(', ')
          : item.performanceTypes.join(', ')
        : interests.length
          ? item.eventTemplate.title + ', ' + interests.join(', ')
          : item.eventTemplate.title
    },
    async applyPromoCode() {
      const { data, errors } = await getPromoCodeByName(
        this.promoCodeInput,
        parseInt(this.event.id),
      )
      const {
        getPromoCodeByName: promoCode,
        getAndValidateMembershipUserByCode,
        findAndValidatePrepaidCouponUserByCodeAndEvent: prepaidCouponUser,
        validateOrderItemAccessCode,
      } = data
      if (
        promoCode === null &&
        getAndValidateMembershipUserByCode === null &&
        prepaidCouponUser === null &&
        !validateOrderItemAccessCode &&
        errors
      ) {
        return (this.errorMessage = errors[0].message)
      }

      // Membership checker
      if (this.event.eventTemplateId && getAndValidateMembershipUserByCode !== null) {
        this.errorMessage = ''

        return this.$emit('applyMembership', getAndValidateMembershipUserByCode)
      }

      // Subscription checker
      if (this.event.eventTemplateId && prepaidCouponUser !== null) {
        this.errorMessage = ''

        this.subscription = { code: prepaidCouponUser.code }
        const redeemedCouponItems = {}
        prepaidCouponUser.redeemedCouponItems.map(id =>
          !redeemedCouponItems[id] ? (redeemedCouponItems[id] = 1) : redeemedCouponItems[id]++,
        )
        const couponItemsIdsAndAmount = {}
        prepaidCouponUser.prepaidCoupon.couponItems.map(
          ci => ci.ticketAmount > 0 && (couponItemsIdsAndAmount[ci.id] = ci.ticketAmount),
        )
        const availableCouponItem = []
        for (const [key, value] of Object.entries(couponItemsIdsAndAmount)) {
          if (!redeemedCouponItems[key] || value > redeemedCouponItems[key]) {
            availableCouponItem.push(key)
          }
        }
        prepaidCouponUser.prepaidCoupon.couponItems =
          prepaidCouponUser.prepaidCoupon.couponItems.filter(ci => {
            if (
              (ci.eventTemplateId === parseInt(this.event.eventTemplateId) ||
                (ci.performanceTypes && ci.performanceTypes.includes(this.event.performanceType)) ||
                this.event.interests.some(i => {
                  if (ci.couponItemInterest.length) {
                    return ci.couponItemInterest.map(cpi => cpi.interest.id).includes(i.id)
                  }
                })) &&
              availableCouponItem.includes(ci.id.toString())
            ) {
              return true
            } else {
              this.unavailablePrepaidCoupons.push(ci)
            }
          })
        if (prepaidCouponUser.prepaidCoupon.couponItems.length === 1) {
          this.couponItemId = prepaidCouponUser.prepaidCoupon.couponItems[0].id
          this.applySubscription(this.couponItemId)
        }

        return (this.prepaidCouponUser = prepaidCouponUser)
      }

      // Order item access code checker
      if (validateOrderItemAccessCode) {
        this.errorMessage = ''
        this.$emit('applyOrderItemAccessCode', this.promoCodeInput)

        return
      }

      // Promo code checker
      if (promoCode) {
        if (promoCode.remainingTickets === 0) {
          this.errorMessage = { workflowCustomer: 'cinehillPackageNoTicketsRemaining', params: {} }
        } else if (
          promoCode.orderItems.every(
            oi => !oi.OrderItemPromoCode.quantity && !oi.OrderItemPromoCode.unlimited,
          )
        ) {
          this.errorMessage = 'workflowsAll.promo_code_has_already_been_used_e132537'
        } else if (!isDateBetween(promoCode)) {
          this.errorMessage = 'workflowsAll.promo_code_is_outdated_bc2862e'
        } else if (promoCode.orderItems.some(oi => !oi.OrderItemPromoCode.quantity)) {
          promoCode.orderItems = promoCode.orderItems.filter(
            oi => oi.OrderItemPromoCode.quantity || oi.OrderItemPromoCode.unlimited,
          )
          this.$emit('applyPromoCode', promoCode)
        } else {
          this.$emit('applyPromoCode', promoCode)
        }
      }
    },
    removePromoCode() {
      if (this.subscription) {
        this.$emit('removeSubscription')
        this.unavailablePrepaidCoupons = []
        this.prepaidCouponUser = null
        this.couponItemId = null
        this.subscription = null
        this.orderItemAccessCode = null
      } else {
        this.$emit('removePromoCode')
      }
    },
    applySubscription(id) {
      this.subscription.couponItemId = id
      this.$emit('applySubscription', this.subscription)
    },
    handleChangeInput() {
      this.invalid = false
      this.errorMessage = ''
    },
  },
}
</script>

<style scoped>
.promo-code-contanier {
  background: #f5f5f5;
  border-radius: 8px 8px 0 0;
  height: 56px;
  margin-bottom: 28px;
  display: flex;
  flex-direction: row;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  position: relative;
}

::v-deep input {
  margin-left: 0 !important;
}

::v-deep .v-input__slot {
  padding: 0 !important;
}

@media screen and (max-width: 600px) {
  .promo-code-container {
    width: auto;
  }

  ::v-deep .v-input__slot:after {
    min-width: fit-content !important;
  }

  ::v-deep .v-input__slot:before {
    min-width: fit-content !important;
  }
}

::v-deep .theme--light.v-messages {
  background: white;
}

::v-deep .v-input input {
  max-height: 32px;
  padding: 10px;
}

::v-deep .v-label {
  padding-left: 10px;
}

::v-deep .v-text-field > .v-input__control > .v-input__slot:after {
  /* min-width: 392px; */
}

::v-deep
  .theme--light.v-text-field.v-input--is-dirty:not(.v-input--has-state)
  .v-input__slot::before {
  /* min-width: 392px; */
}

::v-deep .v-text-field input {
  margin-left: 10px;
}

::v-deep .theme--light.v-text-field:not(.v-input--has-state) .v-input__slot::before {
  /* min-width: 392px; */
}

::v-deep .v-text-field.v-input--has-state .v-input__slot:before {
  /* min-width: 392px; */
}

.promo-code-applied-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1.5rem;
  margin-bottom: 1.25rem;
  padding: 0.5rem 1rem;
  border-radius: 1.2rem;
  font-family: 'Source Sans Pro', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 1rem;
  line-height: 150%;
  color: #333333;
  background-color: transparent;
}

.promo-code-applied-container-regular {
  height: 56px;
  margin-bottom: 28px;
  @media screen and (max-width: 992px) {
    margin-top: 0;
  }
}

.promo-code-applied-container span {
  color: #333333 !important;
}

.promo-code-remove-button {
  color: white;
  background-color: #333333;
  margin: auto;
  padding: 0.5rem 0.5rem;
  font-size: 1.125rem;
  font-weight: bold;
  cursor: pointer;
  margin-left: 0.5rem;
}

::v-deep .v-input__append-inner {
  margin-right: 0.75rem;
}

.activate-button {
  position: absolute;
  top: 0.2rem;
  right: 0;

  color: #333;
  font-variant-numeric: lining-nums proportional-nums;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Raleway;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 700;
  text-transform: uppercase;
}
</style>
